module.exports = __webpack_public_path__ + "static/media/jeff5.87dd0e11.jpg";